function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.127 9.78c-.032.055-.62.946-.993 1.248-.24.211-.535.348-.852.393a.95.95 0 0 1-.81-.218.74.74 0 0 1-.227-.703c.057-.305 1.07-3.916 1.087-4.045a.374.374 0 0 0-.364-.413h-.294c.023-.08.042-.147.069-.225 0-.015 2.358-.358 2.49-.358-.054.188-1.338 4.715-1.373 4.863a.21.21 0 0 0 .096.24.184.184 0 0 0 .237-.034q.366-.396.691-.827a.6.6 0 0 1 .243.078M6.943 3.494a.906.906 0 0 1 .898-.915.92.92 0 1 1-.898.921z",
    fill: "#355C72",
    style: {
      fill: "#355c72",
      fill: "color(display-p3 .2078 .3608 .4471)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.955 1.032a2.016 2.016 0 0 1 2.013 2.013v7.91a2.016 2.016 0 0 1-2.013 2.013h-7.91a2.016 2.016 0 0 1-2.013-2.013v-7.91a2.016 2.016 0 0 1 2.013-2.013zm0-1.032h-7.91A3.045 3.045 0 0 0 0 3.045v7.91A3.044 3.044 0 0 0 3.045 14h7.91A3.044 3.044 0 0 0 14 10.955v-7.91A3.045 3.045 0 0 0 10.955 0",
    fill: "#355C72",
    style: {
      fill: "#355c72",
      fill: "color(display-p3 .2078 .3608 .4471)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAbout);
export default __webpack_public_path__ + "static/media/ic_about.7b2502534d4f21213eb0920e17e96ee3.svg";
export { ForwardRef as ReactComponent };